import DispatcherBindModal from './dispatcherBindModal';

export default DispatcherBindModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/userManagement/dispatcherBind/index.jsx